<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
        <div v-if="pageViewAccess()">
          <a class="btn btn-primary" target="_blank" :href="safeUrl(`${frontEndUrlToUse}ftie/ftie-page-dashboard`)">Page View</a>
        </div>
        <div v-if="reportAccess()">
          <a class="btn btn-primary" target="_blank" :href="safeUrl(`${$root.frontEndUrl}/custom-level-report`)" style="margin-left:10px ;">Custom Level Report</a>
        </div>
        <div>
          <a class="btn btn-primary" target="_blank" :href="safeUrl(`${$root.frontEndUrl}/custom-desc-dashboard`)" style="margin-left:10px ;">Custom Desc Dashboard</a>
        </div>
      </div>
      <!--
            <div v-if="reportAccess()" class="caption-label">
              <span class="mr-2">{{ function_name }} </span>
              <a class="btn btn-primary" target="_blank" :href="`${frontEndUrlToUse}ftie/ftie-page-dashboard`">Page View</a>
              <a class="btn btn-primary" target="_blank" :href="`${$root.frontEndUrl}/custom-level-report`" style="margin-left:10px ;">Custom Level Report</a>
            </div>
            <div v-else class="caption-label">
              <span class="mr-2">{{ function_name }} </span>
              <a class="btn btn-primary" target="_blank" :href="`${frontEndUrlToUse}ftie/ftie-page-dashboard`">Page View</a>
            </div>

  -->


      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-4">
              <div class="label mt-2">Ticket Status</div>
              <div class="row">
                <div class="col-6">
                  <div class="sub-label">Ticket Status:</div>
                  <gtc-multi-select v-model="ticket_status" key-field="value" text-field="text" @blur="focusButton"
                                    :options="ticket_status_options" select-class="w-100"></gtc-multi-select>
                </div>

              </div>
              <div class="label mt-2">Model & Type</div>
              <div class="row">
                <div class="col-6">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="model" key-field="value" text-field="text" @blur="focusButton"
                                    :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
                </div>
                <div class="col-6">
                  <div class="sub-label">Type:</div>
                  <gtc-multi-select v-model="ticket_type" key-field="value" text-field="text" @blur="focusButton"
                                    :options="ftieTypeOptions" select-class="w-100"></gtc-multi-select>
                  <!--<b-form-select v-model="ticket_type" :options="ticket_type_options" label="GTC Owner:"></b-form-select>-->
                  <!-- FROM :options="ticket_type_options" TO :options="ftieTypeOptions" -->
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <b-button ref="focusButton" @click="search()" variant="primary" @keyup.enter.prevent="search()" autofocus>Search</b-button>
                  <b-button v-if="userSites.includes('Getac')" class="row ml-2" @click="getKpiReport()" variant="primary" @blur="focusButton">Kpi Report</b-button>
                  <!--<b-button v-if="!userSites.includes('Getac') && userRoles && userRoles.includes('GRO_SA')" class="row ml-4" @click="getGroReport()" variant="primary">GRO Report</b-button>-->
                </div>
              </div>
            </div>
            <div class="col">
              <div class="label mt-2">Owner</div>
              <div class="row">
                <div class="col-3">
                  <div class="sub-label">GRO Site:</div>
                  <b-form-select v-model="GRO" :options="GRO_options" label="GRO Site:" @change="getRelatedGroOwner(); focusButton();" @select="focusButton"></b-form-select>
                </div>
                <div class="col-3">
                  <div class="sub-label">GRO Owner (L1):</div>
                  <div v-if="GROOwnerList.length == 0">
                    <b-form-input v-model="GRO_owner" placeholder="" label="GRO Owner:" trim @blur="focusButton"></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GRO_owner" :options="GROOwnerList" label="GRO Owner:" @change="focusButton"></b-form-select>
                  </div>
                </div>
                <div class="col">
                  <div class="sub-label">GTC Owner (L2):</div>
                  <div v-if="GTCOwnerList.length == 0">
                    <b-form-input v-model="GTC_owner" placeholder="" label="GTC Owner:" trim @blur="focusButton"></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GTC_owner" :options="GTCOwnerList" label="GTC Owner:" @change="focusButton"></b-form-select>
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">Keyword Category:</div>
                  <div>
                    <b-form-select v-model="keyword_category" :options="KeyWordCategoryList" label="GTC Owner:" @change="focusButton"></b-form-select>
                  </div>
                </div>
              </div>
              <div class="label mt-2">Search</div>
              <div class="row">
                <!--<div class="col-3">
              <div class="sub-label">Model:</div>
              <gtc-multi-select v-model="model" key-field="value" text-field="text"
                                :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
            </div>-->
                <div class="col-6">
                  <div class="sub-label">FTIE Create Date:</div>
                  <div class="d-flex">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" @blur="focusButton"/>
                    <span class="font-weight-bold align-self-center">～</span>
                    <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" @blur="focusButton"/>
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">Customer:</div>
                  <b-form-input v-model="customer"
                                placeholder=""
                                label="Customer" @blur="focusButton" @keydown.enter="search()"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">Keywords: Search by {{chosen_keyword_category}}</div>
                  <b-form-input v-model="keywords"
                                placeholder=""
                                label="Keywords:" @blur="focusButton" @keydown.enter="search()"
                                trim>
                  </b-form-input>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      </div>

      <!--#endregion -- Header ---->
      <!--#region -- Body ---->

      <div class="mt-3" v-if="already_first_search_flag==true">

        <!--#region -- Result Count ---->

        <div class="d-flex">
          <div class="h5 font-weight-bold">{{ rows }} Results</div>
        </div>

        <!--#endregion -- Result Count ---->
        <!-- fix IE Browser min-height: 2.5rem -->
        <div class="table-responsive" style="min-height: 2.5rem">
          <b-table v-if="searchedData!==[]" :fields="fields" :items="searchedData"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   style="width: calc(100% - 10px)"
                   :tbody-tr-class="unreadRowClass">

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template #cell(ftie_id)="data">
              <div class="row">
                <div v-if="data.item.sub_tickets.length !== 0" class="col-2">
                  <button class="btn btn-sm btn-link p-0 btn-svg fontawesome-chevron-down" type="button"
                          style="width: calc(1em + 0.3rem - 2.5px);height: calc(1em + 0.3rem + 0px);margin-bottom: 2px;"
                          data-toggle="collapse" aria-expanded="false" @click="data.toggleDetails"
                          v-b-tooltip.hover.rightbottom title="Collapse for sub ticket"></button>
                </div>
                <div class="col-4 align-self-end">
                  <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.ftie_id }`)">{{ data.item.ftie_id }}</a>
                </div>

              </div>
            </template>

            <template #cell(salesforce_opty_id)="data">
              <div v-if="ifShowOptyLink(data.item.site)">
                <gtc-opportunity :opportunityId="data.item.salesforce_opty_id"
                                 :opportunityName="data.item.salesforce_opty_name" />
              </div>
              <div v-else>
                <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ data.item.salesforce_opty_id }`)">{{ data.item.salesforce_opty_name }}</a>
              </div>
            </template>
            <!-- new add: customer name with sfdc account page link-->
            <!-- salesforce_account_id  -->
            <template #cell(salesforce_account_id)="data">
              <div v-if="ifShowOptyLink(data.item.site)">
                <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }opportunity/account-id/${data.item.salesforce_account_id}`)">{{ data.item.customer }}</a>
              </div>
              <div v-else>
                <a class="link" target="_blank" :href="safeUrl(`${ $root.salesforceUrl }/${ data.item.salesforce_account_id }`)">{{ data.item.customer }}</a>
              </div>
            </template>
            <!-- end region-->
            <template #cell(nre_exist)="data">
              <button class="btn border-radius-0 w-100" v-if="data.item.nre_exist===true"
                      @click="redirectToEtoDashboard(data.item.ftie_id)">
                <img src="../../static/image/icon-NRE_orange.svg" alt="NRE Icon" />
              </button>
              <!--<a class="btn btn-primary" v-if="data.item.nre_exist===true" target="_blank" :href="`${ frontEndUrl }/dashboard/${data.item.ftie_id}`">NRE</a>-->
            </template>
            <template #row-details="data">
              <b-row class="mb-2" v-for="ticket, index in data.item.sub_tickets" :key="index">
                <b-col v-if="(userSites.includes('Getac') || userSites.includes('GTK')) || login_user_name === data.item.gtc_owner" :class="ticket.unread_ftie_id !=null ? 'text-danger col-2' :'col-2'"><b>sub ticket: FTIE#</b><a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ ticket.ftie_id }`)">{{ ticket.ftie_id }}</a></b-col>
                <b-col v-else :class="ticket.unread_ftie_id!=null ? 'text-red col-2' :'col-2'"><b>sub ticket: FTIE#</b>{{ ticket.ftie_id }}</b-col>
                <b-col class="col-2"><b>status:</b> {{ ticket.status}}</b-col>
                <b-col class="col-2"><b>ticket owner:</b> {{ ticket.gtc_owner}}</b-col>
                <b-col class="col-3"><b>Escalated Date:</b> {{ ticket.escalated_date}}</b-col>
                <b-col class="col-auto" v-if="ticket.status!=='Close' && (login_user_name == data.item.gtc_owner)">  <button type="button" class="btn btn-sm btn-danger" @click="showCloseSubTicketModal(ticket.ftie_id)">Close</button> </b-col>
              </b-row>
            </template>
          </b-table>
        </div>
        <div class="d-flex pr-3">
          <div class="ml-auto">
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          :disabled="pageDisabled"
                          :limit="pageLimit"
                          @change="pageChange">
            </b-pagination>
          </div>
        </div>
        <div class="row mx-n1 align-items-center pr-3">
          <div class="px-1 col-auto ml-auto">
            Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
          </div>
          <div class="px-1 col-auto">
            <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
          <div class="px-1 col-auto">rows per page</div>
        </div>
      </div>
      <b-modal centered ok-title="Close" @ok="closeSubTicket"
               cancel-title="Cancel"
               ok-variant="danger"
               ref="CloseSubTicketModal" :title="`FTIE#${closeSubTicketFTIE} Close`"
               button-size="sm">

        <div class="row">
          <div class="col-auto">
            <div class="label mt-2">Close Reason:</div>
          </div>
          <div class="col-auto">
            <gtc-textarea v-model="closeSubTicketReason" />
          </div>
        </div>
      </b-modal>

      <!--#endregion -- Body ---->

    </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'ftie-dashboard',
    data() {
      return {
        function_name: 'FTIE Ticket List Tracking',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        customer: '',
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userInfo: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [
          { value: '', text: 'ALL' },
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-CISCEE', text: 'GMD-CISCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        GRO: '',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        OriginGroOwnerList: [],
        model_options: [],
        ftieTypeList: [],
        ftieTypeOptions: [],
        KeyWordCategoryList: ['Basic Info', 'Bios/EC', 'SN', 'Subject'],
        model: '',
        loadingCnt: 0,

        my_status_options: [{ value: 'InProgress', text: 'In Progress' }, { value: 'Oncoming', text: 'Oncoming' }],
        my_status: '',

        NRE_status_options: [],
        NRE_status: [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }],

        //ticket_type_options: ['ALL', 'Pre-sales', 'Post-sales', 'Customization Support', 'Sector Solution'],
        ticket_type_options: [
          { value: '3rd Party Solution', text: '3rd Party Solution' },
          { value: 'Customization Support', text: 'Customization Support' },
          { value: 'Development Documents', text: 'Development Documents' },
          { value: 'Technical Inquiry', text: 'Technical Inquiry' },
          { value: 'Technical Issue', text: 'Technical Issue' },
          { value: 'Technical Support', text: 'Technical Support' }],
        ticket_type: '',

        ticket_status_options: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }],

        reason_text: null,

        already_first_search_flag: false,
        fields: [
          { key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', thStyle: { 'min-width': '6.5rem !important' }, sortable: true },
          { key: 'salesforce_opty_id', label: 'SF Opty', thClass: 'align-middle', sortable: true },
          { key: 'site', label: 'GRO', thClass: 'align-middle', sortable: true },
          { key: 'salesforce_account_id', label: 'Customer', thClass: 'align-middle', sortable: true },
          //{ key: 'customer', label: 'Customer', thClass: 'align-middle', sortable: true },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: true },
          { key: 'device', label: 'Device', thClass: 'align-middle', sortable: true },
          { key: 'type', label: 'Type', thClass: 'align-middle', sortable: true },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: true },
          { key: 'gro_owner', label: 'Gro Owner', thClass: 'align-middle', sortable: true },
          { key: 'gtc_owner', label: 'Gtc Owner', thClass: 'align-middle', sortable: true },
          { key: 'escalated_date', label: 'Escalate Date', thClass: 'align-middle', sortable: true },
          { key: 'close_date', label: 'Closed Date', thClass: 'align-middle', sortable: true },
          { key: 'nre_exist', label: 'Action', thClass: 'align-middle', sortable: false },
        ],
        searchByFtieId: null,
        searchedData: [],
        GRO_owner: '',
        GTC_owner: 'ALL',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        totalCount: '',
        closeSubTicketFTIE: null,
        closeSubTicketReason: '',
        keyword_category: 'Basic Info'
      }
    },
    created() {
      let self = this;


    },
    computed: {
      rows() {
        return this.totalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      chosen_keyword_category() {
        let self = this;

        if (self.keyword_category === 'Basic Info') return 'IDs, PNs';
        else return self.keyword_category;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
      this.get_ftie_owner_list();
      if (this.$route.params.ftieId) {
        //this.keywords = this.$route.params.keywords;
        this.searchByFtieId = this.$route.params.ftieId;
        console.log("this.searchByFtieId = ");
        console.log(this.searchByFtieId);
        this.search();
      }
    },
    methods: {
      ifShowOptyLink(recordSite) {
        let self = this;
        if (self.reportAccess()) {
          return true;
        } else {
          if (
            (self.userFunctions !== null && _.indexOf(self.userFunctions, 'Customer Success Manager') > -1)
            || //new add logic for filter out internation support SA, like Amanada and stephen.davies
            ( (self.userSites !== null && self.userSites.includes(recordSite)) && (self.userRoles !== null && _.indexOf(self.userRoles, 'International Solution PM') < 0) && (self.userFunctions !== null && _.indexOf(self.userFunctions, 'International Solution PM') < 0))
          ){
            return true;
          }
        }
        return false;
      },
      pageViewAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_functions && _.indexOf(user_functions, 'Tech Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("pageView Access!");
          return true
        }
        return false;
      },

      reportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_functions && _.indexOf(user_functions, 'Tech Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("Access to report!");
          return true
        }
        return false;
      },

      get_ftie_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];
        self.$axios.get(url, { params }, {
          headers: {
            "Authorization": `Token ${self.$store.state.token}`,
          }
        })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list = JSON.parse(res['gro_owner_list']);
              self.GTCOwnerList = gtc_owner_list;
              self.GTCOwnerList.unshift('ALL');

              self.OriginGroOwnerList = gro_owner_list;
              const distinctValues = _.uniq(_.map(gro_owner_list, 'member_gulid'));
              self.GROOwnerList = distinctValues;
              self.GROOwnerList.unshift('ALL');
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            }
            else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if ((self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) {
              if (self.GTCOwnerList && _.indexOf(self.GTCOwnerList, self.login_user_name) > -1) {
                self.GTC_owner = self.login_user_name;
              }
              else {
                self.GTC_owner = 'ALL';
              }
            }
            self.GRO_owner = 'ALL';
            //self.search();
            eventHub.$emit('loading', false);
          });
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        //this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;
        this.ftieTypeList = options.ftie_type_list;
        console.log("options.ftie_type_list:");
        console.log(options.ftie_type_list);

        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);

        this.GTC_owner = options.gtc_owner_default;
        this.GRO_owner = options.gro_owner_default;

        //console.log("GTCOwnerList:");
        //console.log(this.GTCOwnerList);
        //console.log("GROOwnerList:");
        //console.log(this.GROOwnerList);

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var ticketTypeOptionTmp = new Array();
        for (i = 0; i < options.ftie_type_list.length; i++) {
          ticketTypeOptionTmp.push({ value: options.ftie_type_list[i], text: options.ftie_type_list[i] })
        }
        this.ftieTypeOptions = this.ftieTypeOptions.concat(ticketTypeOptionTmp);
      },

      search() {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        this.currentPage = 1;
        this.getFties();
      },
      pageChange(page) {
        this.currentPage = page
        this.getFties() // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.getFties() // api call
      },
      getFties() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/list/';
        console.log('####getFties######');
        var model_selected = [];
        var ticket_type_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.ticket_type.length == 0) {
          ticket_type_selected = ['']
        }
        else {
          for (i = 0; i < self.ticket_type.length; i++) {
            ticket_type_selected.push(self.ticket_type[i]['value'])
          }
        }

        let request_data = {
          model_selected: model_selected,
          ticket_type_selected: ticket_type_selected,
          ticket_status_selected: ticket_status_selected,
          /*my_status_selected: my_status_selected,*/
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          customer: self.customer,
          search_by_ftie_id: self.searchByFtieId,
          login_user_name: self.login_user_name,
          search_type: 'List',
          keyword_category: self.keyword_category
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        //let nreTotalCount = 2;
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['ftie_list']);
              totalCount = parseInt(searchedData[0].total_count);
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.totalCount = totalCount;
          })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.my_status = [];
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
        self.my_status = [];
        if (self.searchByFtieId !== null) {
          self.searchByFtieId = null;
          self.$router.push('/ftie/ftie-dashboard');
        }
        self.searchByFtieId = null;

      },
      redirectToEtoDashboard(ftie_id) {
        let self = this;
        console.log(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
        window.open(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
      },
      showCloseSubTicketModal(ftie_id) {
        let self = this;
        self.closeSubTicketFTIE = ftie_id;
        self.closeSubTicketReason = '';
        self.$refs['CloseSubTicketModal'].show()
      },
      closeSubTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/close-sub-ticket/';

        let request_data = {
          ftie_id: self.closeSubTicketFTIE,
          close_reason: self.closeSubTicketReason
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFties()
            }
          })
        self.$nextTick(() => {
          self.$refs['CloseSubTicketModal'].hide();
        })
      },
      unreadRowClass(item, type) {
        if (item && type === 'row') {
          let unread_sub_tickets = [];
          if (item.sub_tickets.length > 0) {
            unread_sub_tickets = _.reject(item.sub_tickets, { 'unread_ftie_id': null });
          }
          if (item.unread_flag || unread_sub_tickets.length > 0) {
            return 'table-row-highlight table-row-bold'
          } else {
            return null
          }
        } else {
          return null
        }
      },
      getRelatedGroOwner() {
        let self = this;
        let groOptions = _.filter(self.OriginGroOwnerList, item => item.site == self.GRO || self.GRO == '');
        self.GROOwnerList = _.uniq(_.map(groOptions, function (item) {
          return item.member_gulid;
        }));
        self.GRO_owner = 'ALL';
        self.GROOwnerList.unshift('ALL');
      },
      getKpiReport() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/kpi-report/';
        console.log('####getFties######');
        var model_selected = [];
        var ticket_type_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.ticket_type.length == 0) {
          ticket_type_selected = ['']
        }
        else {
          for (i = 0; i < self.ticket_type.length; i++) {
            ticket_type_selected.push(self.ticket_type[i]['value'])
          }
        }
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          model_selected: model_selected,
          ticket_type_selected: ticket_type_selected,
          ticket_status_selected: ticket_status_selected,
          /*my_status_selected: my_status_selected,*/
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          customer: self.customer,
          search_by_ftie_id: self.searchByFtieId,
          login_user_name: self.login_user_name,
          search_type: 'List'
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'ftie_kpi_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      getGroReport() {
        let self = this;
        if (!self.userSites.includes(self.GRO) && (self.GRO == '' || self.GRO == 'ALL')) {
          self.$message.warning('Please chose your belongs site [' + self.userSites.join(',') + '] to download.', 'GRO FTIE report');
          return false;
        }
        let url = self.$root.baseUrl + '/ftie/gro-report/';
        console.log('####getFties######');
        var model_selected = [];
        var ticket_type_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.ticket_type.length == 0) {
          ticket_type_selected = ['']
        }
        else {
          for (i = 0; i < self.ticket_type.length; i++) {
            ticket_type_selected.push(self.ticket_type[i]['value'])
          }
        }
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();

        let request_data = {
          model_selected: model_selected,
          ticket_type_selected: ticket_type_selected,
          ticket_status_selected: ticket_status_selected,
          /*my_status_selected: my_status_selected,*/
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          customer: self.customer,
          search_by_ftie_id: self.searchByFtieId,
          login_user_name: self.login_user_name,
          search_type: 'List'
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };


        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'ftie_gro_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      focusButton() {
        // 重新聚焦按鈕
        setTimeout(() => {
          this.$refs.focusButton.focus();
        }, 100);
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_FTIEDashboard.vue